import type { Member, PointActivity, RewardRedemption } from '../../../components/loyalty/data/types';

export const FETCH_MEMBERS_REQUEST = 'loyalty/members/FETCH_MEMBERS_REQUEST';
export const FETCH_MEMBERS_SUCCESS = 'loyalty/members/FETCH_MEMBERS_SUCCESS';
export const FETCH_MEMBERS_FAILURE = 'loyalty/members/FETCH_MEMBERS_FAILURE';

export const FETCH_MEMBER_PROFILE_REQUEST = 'loyalty/members/FETCH_MEMBER_PROFILE_REQUEST';
export const FETCH_MEMBER_PROFILE_SUCCESS = 'loyalty/members/FETCH_MEMBER_PROFILE_SUCCESS';
export const FETCH_MEMBER_PROFILE_FAILURE = 'loyalty/members/FETCH_MEMBER_PROFILE_FAILURE';

export const FETCH_MEMBER_TRANSACTIONS_SUCCESS = 'loyalty/members/FETCH_MEMBER_TRANSACTIONS_SUCCESS';

export const ADJUST_POINTS_REQUEST = 'loyalty/members/ADJUST_POINTS_REQUEST';
export const ADJUST_POINTS_SUCCESS = 'loyalty/members/ADJUST_POINTS_SUCCESS';
export const ADJUST_POINTS_FAILURE = 'loyalty/members/ADJUST_POINTS_FAILURE';

export const EXPORT_MEMBERS_REQUEST = 'loyalty/members/EXPORT_MEMBERS_REQUEST';
export const EXPORT_MEMBERS_SUCCESS = 'loyalty/members/EXPORT_MEMBERS_SUCCESS';
export const EXPORT_MEMBERS_FAILURE = 'loyalty/members/EXPORT_MEMBERS_FAILURE';

export const TOGGLE_NOTIFICATION_REQUEST = 'loyalty/members/TOGGLE_NOTIFICATION_REQUEST';
export const TOGGLE_NOTIFICATION_SUCCESS = 'loyalty/members/TOGGLE_NOTIFICATION_SUCCESS';
export const TOGGLE_NOTIFICATION_FAILURE = 'loyalty/members/TOGGLE_NOTIFICATION_FAILURE';
export const TOGGLE_NOTIFICATION_REVERT = 'loyalty/members/TOGGLE_NOTIFICATION_REVERT';

export interface PaginationState {
  page: number;
  limit: number;
  totalItems: number;
  totalPages: number;
}

export interface LoyaltyMembersState {
  members: Member[];
  activities: PointActivity[];
  redemptions: RewardRedemption[];
  loading: boolean;
  profileLoading: boolean;
  pagination: PaginationState | null;
  error: string | null;
}
